import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { IBundle } from '../../models/bundle.model';
import { BundleApiService } from '../../services/api/bundle.service';
import { GoogleService } from '../../services/utility/google.service';
import { AppState, IBundleState } from '../app.state';
import { EntityEffects } from '../entity.effects';
import { RouterSelector } from '../router/router.selectors';
import { fromBundleActions } from './bundle.actions';
import { BundleSelector } from './bundle.selectors';

@Injectable()
export class BundleEffects extends EntityEffects<IBundle, IBundleState> {
	constructor(actions$: Actions, store: Store<AppState>, bundleApiService: BundleApiService, private bundleSelector: BundleSelector, private googleService: GoogleService, routerSelector: RouterSelector) {
		super(actions$, store, bundleApiService, bundleSelector, routerSelector, fromBundleActions);
	}

	public onLoaded$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ROUTER_NAVIGATED, fromBundleActions.loaded),
			concatLatestFrom(() => this.store.select(this.bundleSelector.list)),
			concatLatestFrom(() => this.store.select(this.bundleSelector.selected)),
			filter(([[, bundles]]) => bundles.length > 0),
			map(([[, bundles], selected]) => fromBundleActions.selected({ entity: selected != null ? bundles.find(x => x._id == selected._id) : null }))
		)
	);
}
